import React, { useState, useEffect } from 'react';
import { Accordion, Button, Col, Row } from 'react-bootstrap';
import Loader from 'components/shared/Loader';
import { useFetchFAQQuery } from 'store/services/user.service';
import ErrorComponent from "components/shared/ErrorComponent";

const FAQ = () => {
  const { data: faqData, isLoading, isError } = useFetchFAQQuery();


  return (
    <div className="faq-section">
      <Row>
        <Col lg="12" className="my-2">
          {isLoading ? (
            <Loader />
          ): isError ? (
            <ErrorComponent />
          ):(
            <>
              <h2 className="section-title">Frequently Asked Questions</h2>
              <Accordion defaultActiveKey="0">
                {faqData?.map((faq, index) => (
                  <Accordion.Item key={faq._id} eventKey={String(index)}>
                    <Accordion.Header>
                      <span className="question-text">{`${index + 1}. ${faq.question}`}</span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="faq-answer text-muted">
                        <p>{faq.answer}</p>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FAQ;
